<template>
  <div class="main-details">
    <HeadLine>
      {{ section['data']['form']['stageName'] }}
      <!-- @if($info[0]['value'] == 'soil-based')
        ({{$stage['form']['duration']}})
      @endif -->
    </HeadLine>

    <div class="th-fields-container">
      <template v-if="isProportional">
        <div class="column">
          <ValueField :label="section['lang']['temp']" :value="$store.getters['unit/convert']('C', section['data']['form']['temperature']) + ' ' + $store.getters['unit/getLabel']('C')"/>
          <ValueField :label="section['lang']['FInterval']" :value="section['data']['form']['fertigationInterval'] + ' ' + $ml.get('days')"/>
        </div>
        <div class="column">
          <ValueField :label="section['lang']['WStage']" :value="$store.getters['unit/convert']('L', section['data']['form']['waterPerStage']) + ' ' + $ml.get($store.getters['unit/getLabel']('L'))"/>
          <ValueField :label="section['lang']['IInterval']" :value="section['data']['form']['irrigationInterval'] + ' ' + $ml.get('days')"/>
        </div>
      </template>
      <template v-else>
        <div class="column">
          <ValueField :label="section['lang']['temp']" :value="$store.getters['unit/convert']('C', section['data']['form']['temperature']) + ' ' + $store.getters['unit/getLabel']('C')"/>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import HeadLine from './../../components/common/HeadLine';
import ValueField from './../../components/common/ValueField';

export default {
  components: {
    HeadLine,
    ValueField,
  },

  computed: {
    section() {
      return this.$root.data.fertigation;
    },

    isProportional() {
      if(this.$root.data?.program?.fertigation) {
        return this.$root.data.program.fertigation === 'proportional'
      } else {
        return !!this.section['lang']['WStage']
      }
    },
  }
}
</script>

<style lang="scss" scoped>

.main-details {
  padding-bottom: 20px;
}

</style>